import isUndefined from 'lodash/isUndefined';
import type { SingleValue } from 'react-select';

import { Nullable } from 'chaika-frontend-types/frontend-cms';

import { useCheckOnFocus } from '@hooks/useCheckOnFocus';

import { makeValue, resolvePlaceholder } from '../../utils/selectHelpers';
import type { OptionType } from '../../Select';

interface Params {
    options: OptionType[];
    value: Nullable<OptionType>;
    selectedValue: Nullable<string | number> | undefined;
    placeholder: string | undefined;
    title: string | undefined;
    name: string | undefined;
    onChange(params: Nullable<OptionType>, name?: string): void;
}

interface Data {
    isOnFocus: boolean;
    value: Nullable<OptionType>;
    placeholder: string | undefined;
    handleChange(selectedItem: SingleValue<OptionType>): void;
    handleFocus(): void;
    handleBlur(): void;
}

export function useCreatableSelect({
    options,
    value,
    selectedValue,
    placeholder,
    title,
    name,
    onChange,
}: Params): Data {
    const { isOnFocus, handleFocus, handleBlur } = useCheckOnFocus();

    const resolvedValue = !isUndefined(selectedValue) ? makeValue(options, selectedValue, undefined) : value;

    return {
        isOnFocus,
        value: resolvedValue,
        placeholder: resolvePlaceholder({ placeholder, title, isOnFocus }),
        handleChange: selectedItem => onChange(selectedItem, name),
        handleFocus,
        handleBlur,
    };
}
